module.exports = __webpack_public_path__ + "static/media/organizationTemp.fd30c151.xlsx";